module.exports = __webpack_public_path__ + "static/media/hora-icon.c9fb91a6.svg";